import { Flex, Text, VStack } from '@chakra-ui/layout'
import React, { useState } from 'react'
import { ScrollingList } from '~/components/shared/ScrollingList'
import CallLogEntry from '~/pages/CallAnalytics/CallLogs/CallLogEntry'

import { CallLog } from '@mangovoice/types'

interface CallLogsListProps {
  logEntries: CallLog[]
  onCallLogSelected: (entry: CallLog) => void
}

export const CallLogsList = ({
  logEntries,
  onCallLogSelected,
}: CallLogsListProps) => {
  const [selectedCallLogId, setSelectedCallLogId] = useState(-1)

  const handleOnCallLogSelected = (entry: CallLog) => {
    setSelectedCallLogId(entry.id)
    onCallLogSelected(entry)
  }

  return (
    <VStack display="flex" height="100%" alignSelf="stretch" spacing="2px">
      <Flex
        width="100%"
        padding="1rem"
        justifyContent="center"
        alignItems="center"
        gap="0.75rem"
        alignSelf="stretch"
        bg="gray.200"
      >
        <Text textStyle="H3" height="40px" flexGrow="1">
          Test
        </Text>
      </Flex>
      <ScrollingList
        display="flex"
        flex="1"
        width="100%"
        height="70%"
        bg="gray.200"
        px="0.25rem"
        py="0.75rem"
        showLoaderFooter={false}
        scrollbarOptions={{ showOnHoverOnly: true }}
        itemData={logEntries}
        onBuildItemContent={(_, logEntry) => {
          return (
            <CallLogEntry
              call={logEntry}
              selectedCallId={selectedCallLogId}
              onCallLogSelected={handleOnCallLogSelected}
            />
          )
        }}
      />
    </VStack>
  )
}
